import FclQuotation from "./fcl-quotation.component";

export default FclQuotation;
